import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";
import reportAPI from "../../../../api/report";
import {
  BARCHART,
  FLEXDROPDOWN,
  SCREENIPAD,
  STYLEHEAD,
} from "../../../../utils/useStyle";
import DropdownReport from "../../report.dropdwn";
import { GenerateOptionsYear } from "../../../../components/functions/Functions";
import { optionsMonth } from "../common/ReportFilters";

const optionsYear = GenerateOptionsYear();

const DropdownMonthYear = ({ year, setYear, month, setMonth }) => {
  const isMonthDisabled = year.value === "ALL";
  return (
    <div className="flex space-x-2">
      <DropdownReport
        title={"ปี"}
        options={optionsYear}
        value={year}
        setValue={setYear}
        sideFunction={(val) => {
          if (val?.value === "ALL") {
            setMonth({
              label: "ทุกเดือน",
              value: "ALL",
            });
          }
        }}
      />
      <DropdownReport
        title={"เดือน"}
        options={optionsMonth}
        value={month}
        setValue={setMonth}
        disabled={isMonthDisabled}
      />
    </div>
  );
};

const ReportComplication = ({ userDept }) => {
  const [month, setMonth] = React.useState({
    label: "ทุกเดือน",
    value: "ALL",
  });
  const [year, setYear] = React.useState({
    label: "ทุกปี",
    value: "ALL",
  });

  const [data, setData] = React.useState({
    Occlusion: 0,
    WO: 0,
    CO: 0,
    rTPA: 0,
    Infection: 0,
    Displacement: 0,
    Limb_edema: 0,
    DVT: 0,
    Breakage: 0,
    Retained_FB: 0,
    Limb_ischemia: 0,
    Nerve_injury: 0,
    Exit_site_infection: 0,
    total: 0,
  });

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await reportAPI.getComplicationReport({
          year: String(year?.value),
          month: String(month?.value),
          user_department: userDept,
        });
        if (response?.success) {
          setData(response.data);
        }
      } catch (error) {
        console.error("Error fetching complication report:", error);
      }
    };
    fetchData();
  }, [year, month, userDept]);

  const listTable = [
    { name: "Occlusion", count: data?.Occlusion },
    { name: "WO", count: data?.WO },
    { name: "CO", count: data?.CO },
    { name: "rTPA", count: data?.rTPA },
    { name: "Infection", count: data?.Infection },
    { name: "Displacement", count: data?.Displacement },
    { name: "Limb edema", count: data?.Limb_edema },
    { name: "DVT", count: data?.DVT },
    { name: "Breakage", count: data?.Breakage },
    { name: "Retained FB", count: data?.Retained_FB },
    { name: "Limb ischemia", count: data?.Limb_ischemia },
    { name: "Nerve injury", count: data?.Nerve_injury },
    { name: "Exit site infection", count: data?.Exit_site_infection },
  ];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-gray-50 text-gray-700 text-sm px-2 py-1 rounded">
          {payload?.map((item, index) => {
            const count = item.value || 0;
            const percentage =
              data?.total > 0
                ? ((count * 100) / data?.total).toFixed(1)
                : "0.0";
            return (
              <p key={index} className="label">
                {`count : ${count} (${percentage}%)`}
              </p>
            );
          })}
        </div>
      );
    }
    return null;
  };

  const renderCustomLabel = (props) => {
    const { x, y, width, height, value } = props;
    if (!value) return null;
    const percentage =
      data?.total > 0
        ? ((value / data?.total) * 100).toFixed(1) + "%"
        : "0.0%";
    const insideBarPosition = y + height / 2;

    return (
      <g>
        <text
          x={x + width / 2}
          y={insideBarPosition}
          fill="#111827"
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize={12}
        >
          {`${value} (${percentage})`}
        </text>
      </g>
    );
  };

  return (
    <div className="">
      <div className={``}>
        <div className="my-10">
          <>
            <div className={SCREENIPAD}>
              <div className={STYLEHEAD}>
                รายงานภาวะแทรกซ้อนหลังใส่สาย "{year.label}"
              </div>

              <div className={FLEXDROPDOWN}>
                <DropdownMonthYear
                  year={year}
                  setYear={setYear}
                  month={month}
                  setMonth={setMonth}
                />
              </div>
            </div>
            <div>จำนวนสายทั้งหมด {data?.total}</div>
            <div className={BARCHART}>
              <BarChart
                width={900}
                height={380}
                data={listTable}
                margin={{
                  top: 20,
                  bottom: 80,
                }}
              >
                <CartesianGrid strokeDasharray="2 2" />
                <XAxis
                  dataKey="name"
                  interval={0}
                  tick={({ x, y, payload }) => (
                    <g transform={`translate(${x},${y})`}>
                      <text
                        x={0}
                        y={0}
                        dy={10}
                        textAnchor="end"
                        fill="#666"
                        fontSize={11}
                        transform="rotate(-45)"
                      >
                        {payload.value}
                      </text>
                    </g>
                  )}
                />
                <YAxis />
                <Tooltip content={<CustomTooltip />} />
                <Bar
                  label={renderCustomLabel}
                  dataKey="count"
                  fill="#FFCC66"
                />
              </BarChart>
            </div>
          </>
        </div>
      </div>
    </div>
  );
};

export default ReportComplication;
